import {React, observer, useEffect, classNames, useAsObservableSource, useLayoutEffect, useIntersectionObserver, Fragment, trace} from '@api'
import {AssortmentSwatches, AssortmentHeroCards, AssortmentCardBucket, useAssortmentRootStore, useVipLocalStore, AssortmentCardDetailsPanel, AssortmentCardStore, AssortmentCardStoreContext} from '@modules'
import FlipMove from 'react-flip-move'
import * as css from './AssortmentCard.css'
import {AssortmentFloatingToolbar, AssortmentCardTitleDropdownMenuButton} from './AssortmentFloatingToolbar'
import {AssortmentCardHeader, AssortmentCardPerspectives} from './Header'

/// region Components

interface MyProps {
  className?: string
  bucket?: AssortmentCardBucket
  inColumnView?: boolean
}

export const AssortmentCard = observer<MyProps, HTMLDivElement>(function AssortmentCard({className, inColumnView, bucket, ...props}, ref) {
  const root = useAssortmentRootStore(),
    obsProps = useAsObservableSource({...props, bucket, root}),
    store = useVipLocalStore((stores) => new AssortmentCardStore(stores, obsProps)),
    {expanded, isZoomed, root: {animations, canExpandCards}, reallyShow2ndLevel, reallyShowHeader, reallyShowFooter, onContextMenu, toggleExpanded, setRef, ddHandlers} = store

  useLayoutEffect(() => store.registerEffects(), [])

  // const [entry, observerRef] = useIntersectionObserver(),
  //   everVisible = checkForIntersection && (store.everVisible || entry.isIntersecting)
  // useLayoutEffect(() => { if (everVisible) store.everVisible = everVisible}, [everVisible])

  // console.log(store.key, {everVisible})

  //console.log(toJS({bucket, dataMap}, {recurseEverything: true}))

  // console.log(`hoverItem: ${hoverItem?.hoverId}`, hoverItem)

  return (
    <AssortmentCardStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}
           ref={setRef(ref)}
           data-type='AssortmentCard'
           // data-hover-item={hoverItem?.hoverId && false} // causes rerender on every mouse enter/leave of hero
           data-hide-header={!reallyShowHeader ? true : undefined}
           data-hide-2nd-level={!reallyShow2ndLevel ? true : undefined}
           onContextMenu={onContextMenu}
           data-expanded={!inColumnView && expanded}
           data-zoom={isZoomed}
           // data-visible={entry.isIntersecting}
           // data-ever-visible={everVisible}
           draggable
           {...(ddHandlers?.events ?? {})}
      >
        <div className={css.master}
             // ref={observerRef}
             onDoubleClick={toggleExpanded}
             data-type='master'>
          {store.everVisible &&
		   <Fragment>
			   <AssortmentCardPerspectives key='perspectives' className={css.perspectives}/>
			   <AssortmentFloatingToolbar key='toolbar' className={css.floatingToolbar}/>

			   <FlipMove {...animations.assortmentCard}>
                 {reallyShowHeader && <AssortmentCardHeader key='header'/>}

				   <AssortmentHeroCards key={'cards'}/>
                 {reallyShowFooter && <AssortmentSwatches key='swatches'/>}
			   </FlipMove>
		   </Fragment>}
        </div>

        {!inColumnView && <AssortmentCardDetailsPanel className={css.detail}/>}
      </div>
    </AssortmentCardStoreContext.Provider>)
}, {forwardRef: true})

/// endregion



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/AssortmentCard/AssortmentCard.tsx